declare const process: {
  env?: Record<string, string | undefined>;
};

export const AZURE_BLOB_ACCOUNT_URL =
  (process.env && process.env.VUE_APP_AZURE_BLOB_ACCOUNT_URL) ||
  "https://ibhcstagingstorage.blob.core.windows.net";

export const AZURE_BLOB_CONTAINER_NAME = "ibhc-textract";

/**
 * Build a public Azure Blob URL for a given path inside the container.
 * The directory structure must match what was previously in S3.
 *
 * Example:
 *   getAzureBlobUrl("open/interview_end_msg.mp3")
 *   -> https://ibhcstagingstorage.blob.core.windows.net/ibhc-textract/open/interview_end_msg.mp3
 */
export function getAzureBlobUrl(path: string): string {
  const base = AZURE_BLOB_ACCOUNT_URL.replace(/\/+$/, "");
  const container = AZURE_BLOB_CONTAINER_NAME.replace(/\/+$/, "");
  const normalizedPath = path.replace(/^\/+/, "");
  return `${base}/${container}/${normalizedPath}`;
}
